import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useGiftData } from "../../../lib/useMockData";

export default function ValueSection() {
  const { valueData } = useGiftData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{valueData.label}</p>
              <h2 className="section-title">{valueData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">
                {valueData.description}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {valueData.items.map((item, idx) => (
              <ScrollReveal key={item.title} direction="up" delay={idx * 100}>
                <div className="bg-airdoa-cream rounded-lg p-6 md:p-8 h-full">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-5">
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <h3 className="text-lg font-serif font-semibold text-airdoa-navy mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-airdoa-gray leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}